
import axios from '../../axios';

export default async function CardsRequest(
): Promise<any> {
  const response = await axios.get<any>(
    `${process.env.REACT_APP_BASE_URL}/payment/cards`,
  );
  return response.data;
}
